import React from 'react';
import { toast } from 'react-toastify';
import renderHTML from 'react-render-html';
import moment from 'moment';
import EventEmitter from './EventEmitter';
import * as Store from '../store'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

class Utility {
    static toastNotifications = (message, title, type, autoclose = true, companyLogo = "", component = <></>) => {
        // Determine autoClose duration
        let _autoclose = autoclose === false ? false : (typeof autoclose === "number" ? autoclose : 3000);
        let errorToastId = "";
        let warningToastId = "";
        let callbackToastId = "";

        if (type === "success") {
            toast.success(
                <div className="tostify-inner-box">
                    <div className="iconbox">
                        <div className="alert_img">&nbsp;</div>
                    </div>
                    <div className="titleanddescriptionbox">
                        <h1>{title}</h1>
                        <div className="alert_box">
                            <div className="message_dec">{renderHTML(message)}</div>
                        </div>
                    </div>
                </div>, {
                position: 'bottom-left',
                autoClose: _autoclose,
                transition: toast.slide,
                hideProgressBar: false
            }
            );
        } else if (type === "reminder") {
            toast.success(
                <div>
                    <h1>{title}</h1>
                    <div className="alert_box">
                        <div className="alert_img_reminder">&nbsp;</div>
                        <div className="message_dec">{renderHTML(message)}</div>
                    </div>
                </div>, {
                position: 'bottom-left',
                autoClose: _autoclose,
                transition: toast.slide,
                hideProgressBar: false,
                closeOnClick: true
            }
            );
        } else if (type === "info") {
            toast.success(
                <div className="tostify-inner-box errorToastMsg">
                    <div className="iconbox">
                        <div className="alert_img_info">&nbsp;</div>
                    </div>
                    <div className="titleanddescriptionbox">
                        <h1 className="info_title_text">{title}</h1>
                        <div className="alert_box">
                            <div className="message_dec">{renderHTML(message)}</div>
                        </div>
                    </div>
                </div>, {
                position: 'bottom-left',
                autoClose: _autoclose,
                transition: toast.slide,
                hideProgressBar: false
            }
            );
        } else if (type === "error") {
            errorToastId = message;
            if (!toast.isActive(errorToastId)) {
                toast.error(
                    <div className="tostify-inner-box errorToastMsg">
                        <div className="iconbox">
                            <div className="alert_img_error">&nbsp;</div>
                        </div>
                        <div className="titleanddescriptionbox">
                            <h1>{title}</h1>
                            <div className="alert_box">
                                <div className="message_dec">{renderHTML(message)}</div>
                            </div>
                        </div>
                    </div>, {
                    position: 'bottom-left',
                    autoClose: _autoclose,
                    transition: toast.slide,
                    hideProgressBar: true,
                    toastId: errorToastId,
                    closeOnClick: true
                }
                );
            }
        } else if (type === "warning") {
            warningToastId = message;
            if (!toast.isActive(warningToastId)) {
                toast.warning(
                    <div className="tostify-inner-box">
                        <div className="iconbox">
                            <div className="alert_img_warning">&nbsp;</div>
                        </div>
                        <div className="titleanddescriptionbox">
                            <h1>{title}</h1>
                            <div className="alert_box">
                                <div className="message_dec">{renderHTML(message)}</div>
                            </div>
                        </div>
                    </div>, {
                    position: 'bottom-left',
                    autoClose: _autoclose,
                    transition: toast.slide,
                    hideProgressBar: false,
                    toastId: warningToastId,
                    closeOnClick: true
                }
                );
            }
        } else if (type === "longError") {
            errorToastId = message;
            if (!toast.isActive(errorToastId)) {
                toast.error(
                    <div className="warning_message_box_long">
                        <div className="iconbox">
                            <div className="alert_img_warning">&nbsp;</div>
                        </div>
                        <h1 className="error_title">{title}</h1>
                        <div className="message_descriptipn error_title_dec">{renderHTML(message)}</div>
                    </div>, {
                    position: 'bottom-left',
                    autoClose: false,
                    transition: toast.slide,
                    hideProgressBar: true,
                    toastId: errorToastId,
                    closeOnClick: true
                }
                );
            }
        } else if (type === "callback") {
            callbackToastId = message;
            if (!toast.isActive(callbackToastId)) {
                toast(component, {
                    position: toast.POSITION.TOP_LEFT,
                    transition: toast.slide,
                    toastId: callbackToastId,
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: false,
                    progress: undefined,
                    closeButton: false
                });
            }
        }
    }

    static allRoute = () => {
        let routesUrl = [

        ];
        return routesUrl;
    }

    static toastNotificationsDismissAll = () => {
        toast.dismiss();
    }

    static displayNameFormat = (first_name = "", last_name = "") => {
        let concatname = first_name + " " + last_name
        return concatname
    }

    //role wise permission and userwise permission
    static roleWisePermission = (userId, visitorId, roleName) => {
        let permission = false;
        if (roleName == 'app_admin') {
            permission = true;
        } else {
            if (userId == visitorId) {
                permission = true;
            }
        }

        return permission;
    }

    static durationFormat = (num) => {
        let returnNumber = "";
        let durationCount = num.split('.');
        if (num == "0.50") {
            let nextDuration = durationCount[1].split("");
            returnNumber = "0." + nextDuration[0];
        } else {
            returnNumber = durationCount[0];
        }
        return returnNumber
    }

    static capitalizeFirstLetterOfEachWord(str) {
        // Split the string into words
        const words = str.split(/\s+/);
        // Capitalize the first letter of each word
        const capitalizedWords = words.map(word => {
            if (word.length > 0) {
                return word.charAt(0).toUpperCase() + word.slice(1);
            } else {
                return word; // If the word is empty, keep it as is
            }
        });
        // Join the words back into a string with spaces
        return capitalizedWords.join(' ');
    }

    static customDatePicker = () => {
        const myCustomLocale = {
            // months list by order
            months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ],

            // week days by order
            weekDays: [
                {
                    name: 'Monday',
                    short: 'M',
                },
                {
                    name: 'Tuesday',
                    short: 'T',
                },
                {
                    name: 'Wednesday',
                    short: 'W',
                },
                {
                    name: 'Thursday',
                    short: 'T',
                },
                {
                    name: 'Friday',
                    short: 'F',
                },
                {
                    name: 'Saturday',
                    short: 'S',
                    isWeekend: true,
                },
                {
                    name: 'Sunday', // used for accessibility 
                    short: 'S', // displayed at the top of days' rows
                    isWeekend: true, // is it a formal weekend or not?
                }
            ],

            // just play around with this number between 0 and 6
            weekStartingIndex: 0,

            // return a { year: number, month: number, day: number } object
            getToday(gregorainTodayObject) {
                return gregorainTodayObject;
            },

            // return a native JavaScript date here
            toNativeDate(date) {
                return new Date(date.year, date.month - 1, date.day - 1);
            },

            // return a number for date's month length
            getMonthLength(date) {
                return new Date(date.year, date.month, 0).getDate();
            },

            // return a transformed digit to your locale
            transformDigit(digit) {
                return digit;
            },

            // texts in the date picker
            nextMonth: 'Next Month',
            previousMonth: 'Previous Month',
            openMonthSelector: 'Open Month Selector',
            openYearSelector: 'Open Year Selector',
            closeMonthSelector: 'Close Month Selector',
            closeYearSelector: 'Close Year Selector',
            defaultPlaceholder: 'Select...',

            // for input range value
            from: 'from',
            to: 'to',


            // used for input value when multi dates are selected
            digitSeparator: ',',

            // if your provide -2 for example, year will be 2 digited
            yearLetterSkip: 0,

            // is your language rtl or ltr?
            isRtl: false,
        }
        return myCustomLocale;
    }

    static currentMonthFirstDayLastDayFormat = () => {
        const currentDate = moment();
        const firstDayOfMonth = currentDate.clone().startOf('month');
        const lastDayOfMonth = currentDate.clone().endOf('month');
        const firstDayOfMonthString = firstDayOfMonth.format('YYYY-MM-DD');
        const lastDayOfMonthString = lastDayOfMonth.format('YYYY-MM-DD');
        let returnCurrentMonthFirstDayLastDay = {
            start_date: firstDayOfMonthString,
            end_date: lastDayOfMonthString,
        }
        return returnCurrentMonthFirstDayLastDay
    }

    static getRoleObjectByEventKey = (eventKey) => {
        let roleJsonData = Store.default.getState().LoginReducer.userCredentials.user_details.role_permission;
        let foundObject = JSON.parse(roleJsonData).find(item => item.eventKey === eventKey);
        return foundObject || {};
    }

    static getCurrencySymbol(currencyCode) {

        function identifyCurrency(value) {
            // Regular expression to match three-letter currency codes
            const currencyCodeRegex = /^[A-Z]{3}$/;

            // Check if the value matches the currency code regex
            if (currencyCodeRegex.test(value)) {
                return false;
            } else {
                return true;
            }
        }

        try {
            const locale = localStorage.getItem('i18nextLng') || 'en-US'; // Default to 'en-US' if locale is not available
            const formatter = new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currencyCode,
            });
            const parts = formatter.formatToParts(1);
            const symbol = parts.find(part => part.type === 'currency')?.value;
            let symbolOrNot = identifyCurrency(symbol);
            if (!symbolOrNot) {
                switch (currencyCode) {
                    case 'AED':
                        return 'د.إ'; // UAE Dirham symbol
                    case 'BDT':
                        return '৳'; // Bangladeshi Taka symbol
                    default:
                        return symbol;
                }
            }

            return symbol;
        } catch (error) {
            return '';
        }
    }

    static calculateDaysNights(startDateStr, endDateStr) {
        const startDate = moment(startDateStr);
        const endDate = moment(endDateStr);
        if (!startDate.isValid() || !endDate.isValid()) {
            return { days: 0, nights: 0 };
        }
        const MS_PER_DAY = 24 * 60 * 60 * 1000; // milliseconds per day
        // Calculate the time difference in milliseconds
        const timeDifference = endDate.toDate().getTime() - startDate.toDate().getTime();
        // Calculate the number of days and nights
        const days = Math.floor(timeDifference / MS_PER_DAY) + 1;
        const nights = Math.ceil(timeDifference / MS_PER_DAY);
        return { days, nights };
    }

    static capitalizeFirstLetterOfEachWord(str) {
        // Split the string into words
        const words = str.split(/\s+/);
        // Capitalize the first letter of each word
        const capitalizedWords = words.map(word => {
            if (word.length > 0) {
                return word.charAt(0).toUpperCase() + word.slice(1);
            } else {
                return word; // If the word is empty, keep it as is
            }
        });
        // Join the words back into a string with spaces
        return capitalizedWords.join(' ');
    }

    static capitalizeOnlyFirstLetter = (str) => {
        if (!str || typeof str !== 'string') {
            return '';
        }

        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    static getTwoDecimalNumber(value) {
        let floatValue = parseFloat(value);
        if (isNaN(floatValue)) {
            floatValue = 0
        }
        return floatValue.toFixed(2)
    }

    static validateUPI(upiId) {
        // Regular expression pattern for UPI ID validation
        const upiRegex = /^[\w.-]+@[\w.-]+$/;

        // Check if the provided UPI ID matches the pattern
        return upiRegex.test(upiId);
    }

    static debounce = (func, delay) => {
        let timeoutId;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(context, args);
            }, delay);
        };
    }
    static debounceButton = (func, delay) => {
        let timeoutId;
        let lastArgs;
        let lastThis;

        const later = function () {
            func.apply(lastThis, lastArgs);
            lastThis = null;
            lastArgs = null;
        };

        return function () {
            lastThis = this;
            lastArgs = arguments;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(later, delay);
        };
    }

    static throttle(func, limit) {
        let inThrottle;
        return function () {
            const context = this;
            const args = arguments;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => inThrottle = false, limit);
            }
        };
    }

    static acceptFileType = () => {
        let fileType = ".jpg, .jpeg, .png"
        return fileType;
    }

    static checkFileType(file, allowedTypes) {
        const allowedTypesArray = allowedTypes.split(',').map(type => type.trim());
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const arr = new Uint8Array(reader.result.slice(0, 4));
                const header = Array.from(arr, byte => byte.toString(16).padStart(2, '0')).join('');
                const magicNumbers = {
                    'jpg': 'ffd8ffe0',
                    'jpeg': 'ffd8ffe1',
                    'png': ['89504e47', '0000001c']
                };
                for (let type of allowedTypesArray) {
                    const typeWithoutDot = type.replace('.', '');
                    const magicNumber = magicNumbers[typeWithoutDot];
                    if (Array.isArray(magicNumber)) {
                        if (magicNumber.includes(header)) {
                            resolve({ isValid: true, fileType: type });
                            return;
                        }
                    } else {
                        if (header.startsWith(magicNumber)) {
                            resolve({ isValid: true, fileType: type });
                            return;
                        }
                    }
                }

                let extension;
                switch (header) {
                    case "89504e47":
                        extension = "png";
                        break;
                    case "504b0304":
                        extension = "zip";
                        break;
                    case "52494646":
                        extension = "webp";
                        break;
                    case "47494638":
                        extension = "gif";
                        break;
                    case "ffd8ffe0":
                    case "ffd8ffe1":
                    case "ffd8ffe2":
                        extension = "jpg";
                        break;
                    default:
                        extension = "txt";
                }
                // If file type doesn't match any of the allowed types
                resolve({ isValid: false, fileType: extension });
            };
            reader.onerror = () => {
                reject("Error reading file");
            };
            // Read the file
            reader.readAsArrayBuffer(file);
        });
    }

    static hasNonZeroValues(input) {
        const numbers = input.split(',').map(Number);
        return numbers.some(num => num !== 0);
    }
    static getMonthName(monthNumber) {
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        return months[monthNumber];
    }

    static bookingDateUi = (classNameCss, actualDate, inOutDate, type) => {
        let renderDate = actualDate;
        let tooltipText = null;

        if (inOutDate !== null) {
            const isDifferentDate = !moment(actualDate).isSame(inOutDate, 'day');
            tooltipText = isDifferentDate ? `Actual ${type} : \n ${moment(inOutDate.toString()).format('DD-MM-YYYY HH:mm')}` : null;
        }
        let colors = '#000000';
        colors = inOutDate !== null && tooltipText ? 'red' : '#000000';

        return (
            <div className={classNameCss}>
                {inOutDate === null ? (
                    <div style={{ color: colors }}>{moment(renderDate.toString()).format('DD-MM-YYYY HH:mm')}</div>
                ) : (
                    tooltipText ? (
                        <OverlayTrigger overlay={<Tooltip>{tooltipText.split('\n').map((line, ind) => (
                            <div key={ind}>{line}</div>
                        ))}</Tooltip>}>
                            <span style={{ color: colors }}>{moment(renderDate.toString()).format('DD-MM-YYYY HH:mm')}</span>
                        </OverlayTrigger>
                    ) : (
                        <span style={{ color: colors }}>{moment(renderDate.toString()).format('DD-MM-YYYY HH:mm')}</span>
                    )
                )}
            </div>
        );
    };

    static getCurrencyValue(value, currencyCode = 'INR') {
        let getSymbol = this.getCurrencySymbol(currencyCode);
        let floatValue = parseFloat(value);
        if (isNaN(floatValue)) {
            floatValue = 0;
        }
        return getSymbol + floatValue.toFixed(2);
    }

    //get currency symbol
    static getCurrencySymbol(currencyCode) {
        function identifyCurrency(value) {
            // Regular expression to match three-letter currency codes
            const currencyCodeRegex = /^[A-Z]{3}$/;

            // Check if the value matches the currency code regex
            if (currencyCodeRegex.test(value)) {
                return false;
            } else {
                return true;
            }
        }

        try {
            const locale = localStorage.getItem('i18nextLng') || 'en-US'; // Default to 'en-US' if locale is not available
            const formatter = new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currencyCode,
            });
            const parts = formatter.formatToParts(1);
            const symbol = parts.find(part => part.type === 'currency')?.value;
            let symbolOrNot = identifyCurrency(symbol);
            if (!symbolOrNot) {
                switch (currencyCode) {
                    case 'AED':
                        return 'د.إ'; // UAE Dirham symbol
                    case 'BDT':
                        return '৳'; // Bangladeshi Taka symbol
                    default:
                        return symbol;
                }
            }

            return symbol;
        } catch (error) {
            return '';
        }
    }
    static buildUrlParams(searchData) {
        const searchParams = new URLSearchParams();
        if (searchData.destination) {
            searchParams.set('destination', typeof searchData.destination === 'string' ?
                searchData.destination : JSON.stringify(searchData.destination));
        }
        if (searchData.start_date) {
            searchParams.set('startDate', moment(searchData.start_date).format('YYYY-MM-DD'));
        }
        if (searchData.end_date) {
            searchParams.set('endDate', moment(searchData.end_date).format('YYYY-MM-DD'));
        }
        if (searchData.adult) {
            searchParams.set('adult', searchData.adult);
        }
        if (searchData.children && searchData.children > 0) {
            searchParams.set('children', searchData.children);
        }

        if (searchData?.tour_type) {
            searchParams.set('tour_type', searchData.tour_type);
        }

        if (searchData?.property_type) {
            searchParams.set('property_type', searchData.property_type);
        }

        if (searchData?.country) {
            searchParams.set('country', searchData.country);
        }

        // Add filter parameters to URL
        if (searchData?.filterData) {
            // Add property types
            if (searchData.filterData.property_type && searchData.filterData.property_type.length > 0) {
                // Check if property_type is an array before calling join
                if (Array.isArray(searchData.filterData.property_type)) {
                    searchParams.set('property_type', searchData.filterData.property_type.join(','));
                } else {
                    // Handle case when property_type is not an array
                    searchParams.set('property_type', searchData.filterData.property_type.toString());
                }
            }

            // Add amenities
            if (searchData.filterData.amenities && searchData.filterData.amenities.length > 0) {
                // Check if amenities is an array before calling join
                if (Array.isArray(searchData.filterData.amenities)) {
                    searchParams.set('amenities', searchData.filterData.amenities.join(','));
                } else {
                    searchParams.set('amenities', searchData.filterData.amenities.toString());
                }
            }

            // Add meals
            if (searchData.filterData.meals && searchData.filterData.meals.length > 0) {
                // Check if meals is an array before calling join
                if (Array.isArray(searchData.filterData.meals)) {
                    searchParams.set('meals', searchData.filterData.meals.join(','));
                } else {
                    searchParams.set('meals', searchData.filterData.meals.toString());
                }
            }

            // Add budget range
            if (searchData.filterData.budget_min !== undefined && searchData.filterData.budget_min !== "") {
                searchParams.set('budget_min', searchData.filterData.budget_min);
            }
            if (searchData.filterData.budget_max !== undefined && searchData.filterData.budget_max !== "") {
                searchParams.set('budget_max', searchData.filterData.budget_max);
            }

            // Add property ratings
            if (searchData.filterData.property_rating && searchData.filterData.property_rating.length > 0) {
                // Check if property_rating is an array before calling join
                if (Array.isArray(searchData.filterData.property_rating)) {
                    searchParams.set('property_rating', searchData.filterData.property_rating.join(','));
                } else {
                    searchParams.set('property_rating', searchData.filterData.property_rating.toString());
                }
            }
        }
        return searchParams.toString();
    }
    static decodeUrlParams = (url) => {
        // Create a completely fresh search data object
        let searchData = {
            filterData: {
                // Initialize filter arrays with empty arrays by default
                property_type: [],
                amenities: [],
                meals: [],
                property_rating: []
            }
        };
        const searchParams = new URLSearchParams(url);

        if (searchParams.toString()) {
            // Extract all parameters from URL
            const destination = searchParams.get('destination');
            const startDate = searchParams.get('startDate');
            const endDate = searchParams.get('endDate');
            const adult = searchParams.get('adult');
            const children = searchParams.get('children');
            const tour_type = searchParams.get('tour_type');
            const property_type = searchParams.get('property_type');
            const amenities = searchParams.get('amenities');
            const meals = searchParams.get('meals');
            const budget_min = searchParams.get('budget_min');
            const budget_max = searchParams.get('budget_max');
            const property_rating = searchParams.get('property_rating');



            // Set minimal defaults for required fields
            searchData.children = 0; // Default to 0 children

            // Parse and set the destination
            if (destination) {
                // SearchPanel expects destination in a specific format
                // It could be a string or an object with value and label properties
                const decodedDestination = decodeURIComponent(destination);

                // Create destination in the format expected by SearchPanel component
                // This will ensure the dropdown selection appears correctly
                searchData.destination = decodedDestination;
            }

            const country = searchParams.get('country');
            if (country) {
                searchData.country = decodeURIComponent(country);
            }

            // Parse and set dates
            if (startDate) {
                searchData.start_date = new Date(startDate);
            }

            if (endDate) {
                searchData.end_date = new Date(endDate);
            }

            // Parse and set guest counts
            if (adult) {
                searchData.adult = parseInt(adult);
            }

            if (children) {
                const childrenCount = parseInt(children);
                searchData.children = childrenCount;
            }

            if (tour_type) {
                searchData.tour_type = decodeURIComponent(tour_type);
            }

            // Parse and set filters
            if (property_type) {
                // First decode the URL encoded string
                const decodedPropertyType = decodeURIComponent(property_type);
                searchData.property_type = decodedPropertyType;
                // Then split by comma
                const propertyTypeArray = decodedPropertyType.includes(',') ?
                    decodedPropertyType.split(',') : [decodedPropertyType];

                // FilterPanel seems to expect property_type as a simple string or array of strings
                // Let's make sure it's in the right format
                searchData.filterData.property_type = propertyTypeArray;
            }

            if (amenities) {
                // First decode the URL encoded string
                const decodedAmenities = decodeURIComponent(amenities);
                // Then split by comma
                searchData.filterData.amenities = decodedAmenities.includes(',') ?
                    decodedAmenities.split(',') : [decodedAmenities];
            }

            if (meals) {
                // First decode the URL encoded string
                const decodedMeals = decodeURIComponent(meals);
                // Then split by comma
                searchData.filterData.meals = decodedMeals.includes(',') ?
                    decodedMeals.split(',') : [decodedMeals];
            }

            if (budget_min) {
                searchData.filterData.budget_min = parseInt(budget_min);
            }

            if (budget_max) {
                searchData.filterData.budget_max = parseInt(budget_max);
            }

            if (property_rating) {
                // First decode the URL encoded string
                const decodedPropertyRating = decodeURIComponent(property_rating);
                // Then split by comma
                searchData.filterData.property_rating = decodedPropertyRating.includes(',') ?
                    decodedPropertyRating.split(',') : [decodedPropertyRating];
            }
        }
        return searchData;
    }

    /**
     * Map planner tab / category name to tag value
     * @param {string} key 
     * @returns {string}
     */
    static getTagByKey = (key) => {
        const tagMap = {
            "Domestic": "domestic",
            "International": "international",
            "Sweet Bengal": "sweet_bengal",
            "Riding & Adventure": "riding_adventure",
            "Festival": "festival",
            "Historical": "historical_expeditions",
            "Jungle": "jungle",
            "India Offbeat": "india_offbeat",
            "Spiritual Theme": "spiritual_theme",
            "Trek": "trek",
            "Historical Expeditions": "historical_expeditions",
            "Weekend": "weekend",
            "Curated experience": "curated_experience",
            "Signature Tours": "signature_tours",
            "Exclusive Collaboration": "exclusive_collaboration",
            "United for Travel": "united_for_travel",
            "Roadtrip": "roadtrip",
            "Ecofriendly & Sustainable Tour": "ecofriendly_sustainable_tour",
            "Cultural Tour": "cultural_tour",
            "Retreat": "retreat",
            "Solo": "solo",
            "Stranger": "stranger",
            "Gen Z / Millennial": "gen_z_millennial",
            "Senior Citizen": "senior_citizen",
            "Senior Citizen2": "senior_citizen",
            "The Staying's Choice": "the_staying_s_choice_stay",
            "The Staying's Network": "the_staying_own_network",
            "Villa": "villa",
            "Apartment": "apartment",
            "Farm House": "farm_house",
            "Luxury Camp": "luxury_camp",
            "Camp": "camp",
            "Guest Houses": "guest_houses",
            "Hostels & Backpacker Lodges": "hostels_backpacker_lodges",
            "Bed & Breakfasts": "bed_breakfasts",
            "Luxury Hotels": "luxury_hotels",
            "5-Star Hotels": "5_star_hotels",
            "3-Star Hotels": "3_star_hotels",
            "4-Star Hotels": "4_star_hotels",
            "Luxury Resorts": "luxury_resorts",
            "Lodge": "lodge",
            "Budget Hotels": "budget_hotels",
            "Economy Lodges": "economy_lodges",
            "Heritage Hotels & Palaces": "heritage_hotels_palaces",
            "Tented Camps & Glamping": "tented_camps_glamping",
            "Wellness Retreats": "wellness_retreats"
        };
        if (!key) return "";
        return tagMap[key] || tagMap[typeof key === 'string' ? key.trim() : key] || key;
    };
    static getKeyByTags = (key) => {
        const tagMap = {
            "domestic": "Domestic",
            "international": "International",
            "sweet_bengal": "Sweet Bengal",
            "riding_adventure": "Riding & Adventure",
            "festival": "Festival",
            "historical_expeditions": "Historical Expeditions",
            "jungle": "Jungle",
            "india_offbeat": "India Offbeat",
            "spiritual_theme": "Spiritual Theme",
            "trek": "Trek",
            "weekend": "Weekend",
            "curated_experience": "Curated experience",
            "signature_tours": "Signature Tours",
            "exclusive_collaboration": "Exclusive Collaboration",
            "united_for_travel": "United for Travel",
            "roadtrip": "Roadtrip",
            "ecofriendly_sustainable_tour": "Ecofriendly & Sustainable Tour",
            "cultural_tour": "Cultural Tour",
            "retreat": "Retreat",
            "solo": "Solo",
            "stranger": "Stranger",
            "gen_z_millennial": "Gen Z / Millennial",
            "senior_citizen": "Senior Citizen",
            "the_staying_s_choice_stay": "The Staying's Choice",
            "the_staying_own_network": "The Staying's Network",
            "villa": "Villa",
            "apartment": "Apartment",
            "farm_house": "Farm House",
            "luxury_camp": "Luxury Camp",
            "camp": "Camp",
            "guest_houses": "Guest Houses",
            "hostels_backpacker_lodges": "Hostels & Backpacker Lodges",
            "bed_breakfasts": "Bed & Breakfasts",
            "luxury_hotels": "Luxury Hotels",
            "5_star_hotels": "5-Star Hotels",
            "3_star_hotels": "3-Star Hotels",
            "4_star_hotels": "4-Star Hotels",
            "luxury_resorts": "Luxury Resorts",
            "lodge": "Lodge",
            "budget_hotels": "Budget Hotels",
            "economy_lodges": "Economy Lodges",
            "heritage_hotels_palaces": "Heritage Hotels & Palaces",
            "tented_camps_glamping": "Tented Camps & Glamping",
            "wellness_retreats": "Wellness Retreats"
        };
        if (!key) return "";
        return tagMap[key] || tagMap[typeof key === 'string' ? key.trim() : key] || key;
    };

    static getPlannerTag = (key) => {
        return Utility.getTagByKey(key);
    };

    // Stay property tags shown under "Browse by property type" on the home page
    static PROPERTY_TAG_LABELS = [
        'Villa', 'Apartment', 'Farm House', 'Luxury Camp', 'Camp', 'Guest Houses',
        'Hostels & Backpacker Lodges', 'Bed & Breakfasts', 'Luxury Hotels',
        '5-Star Hotels', '3-Star Hotels', '4-Star Hotels', 'Luxury Resorts',
        'Lodge', 'Budget Hotels', 'Economy Lodges', 'Heritage Hotels & Palaces',
        'Tented Camps & Glamping', 'Wellness Retreats'
    ];

    // Normalize a tag/property-type label for fuzzy matching (lowercase, alnum only)
    static normalizeTagName = (name) => String(name || '').toLowerCase().replace(/[^a-z0-9]/g, '');
}


export default Utility;